import { Price, cn, Discount } from '@divlab/divanui';

import { useMeta } from '@Queries/Meta';
import { useRequest } from '@Contexts/Request';
import styles from './DefaultPrices.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { ProductPriceData } from '@Types/Product';

interface DefaultPricesProps extends HTMLAttributes<HTMLDivElement> {
  price: ProductPriceData;
}

const DefaultPrices: FC<DefaultPricesProps> = (props) => {
  const { className, price, ...restProps } = props;
  const { isUzb } = useRequest();
  const expiredPrice = price?.expired;
  const discountPrice = price?.discount;
  const {
    data: { currency },
  } = useMeta();

  return (
    <div
      className={cn(styles.containerPrices, className)}
      itemProp='offers'
      itemScope
      itemType='http://schema.org/Offer'
      {...restProps}
    >
      <meta itemProp='priceCurrency' content={currency} />
      <Price
        className={cn(styles.actualPrice, {
          [styles.longPrice]: isUzb,
        })}
        price={price.actual}
        itemProp='price'
        content={price.actual.toString()}
      />
      <link itemProp='availability' href='http://schema.org/InStock' />
      {(expiredPrice > 0 || discountPrice > 0) && (
        <div className={styles.wrap}>
          {expiredPrice > 0 && (
            <Price
              expired
              className={cn(styles.expiredPrice, { [styles.longPrice]: isUzb })}
              price={expiredPrice}
              withoutCurrency={isUzb}
            />
          )}
          {discountPrice > 0 && (
            <Discount
              className={cn(styles.discount, { [styles.longPrice]: isUzb })}
              value={discountPrice}
              view='red'
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DefaultPrices;
